export default __webpack_public_path__ + "static/media/marker-small.e38dcf58.svg";